import React, { useId } from 'react';

import { LanguageIcon } from '@/Assets/Languages/types';

export const Polish: LanguageIcon = () => {
    const clipPathId = useId();

    return (
        <svg width="512" height="512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
            <g clipPath={`url(#${clipPathId})`}>
                <path
                    d="M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z"
                    fill="#F0F0F0"
                />
                <path d="M512 256C512 397.384 397.384 512 256 512C114.616 512 0 397.384 0 256" fill="#D80027" />
            </g>
            <defs>
                <clipPath id={clipPathId}>
                    <rect width="512" height="512" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
